import { Component } from '@angular/core';
import { Router } from '@angular/router';
import firebase from 'firebase/compat/app';
import { Project } from '../interfaces/project';
import { Partner } from '../interfaces/partner';

@Component({
  selector: 'app-recycling-bin',
  templateUrl: './recycling-bin.component.html',
  styleUrl: './recycling-bin.component.css'
})
export class RecyclingBinComponent {
constructor(private router: Router) { };

  rejectedProjects: Project[] = [];
  rejectedProjectsPaginated: Project[][] = [];
  rejectedProjectsPage = 0;

  rejectedPartners: Partner[] = [];
  rejectedPartnersPaginated: Partner[][] = [];
  rejectedPartnersPage = 0;

  pendingPartners: Partner[] = [];
  pendingPartnersPaginated: Partner[][] = [];
  pendingPartnersPage = 0;

  ngOnInit() {
    this.getRejectedProjects().then(() => {
      this.generateRejectedProjectsPaginated()
    });

    this.getRejectedPartners().then(() => {
      this.generateRejectedPartnersPaginated()
    });

    this.getPendingPartners().then(() => {
      this.generatePendingPartnersPaginated()
    });
  }

  trackById(index: number, project: Project): string {
    return project.id!;
  }

  trackByPartnerId(index: number, partner: Partner): string {
    return partner.id!;
  }

  onProjectCardClicked(id: any) {
    this.router.navigate(['/project', id]);
  }

  onPartnerCardClicked(urlOrg: any) {
    this.router.navigate(['/partner', urlOrg]);
  }

  generateRejectedProjectsPaginated() {
    for (let i = 0; i < this.rejectedProjects.length; i += 10) {
      this.rejectedProjectsPaginated.push(this.rejectedProjects.slice(i, i + 10));
    }
  }

  generateRejectedPartnersPaginated() {
    for (let i = 0; i < this.rejectedPartners.length; i += 10) {
      this.rejectedPartnersPaginated.push(this.rejectedPartners.slice(i, i + 10));
    }
  }

  generatePendingPartnersPaginated() {
      for (let i = 0; i < this.pendingPartners.length; i += 10) {
        this.pendingPartnersPaginated.push(this.pendingPartners.slice(i, i + 10));
      }
    }

  async getPendingPartners() {
    const snapshot = await firebase.firestore().collection('pendingPartners').get();
    snapshot.forEach((doc) => {
      const data = { id: doc.id, ...doc.data() };
      this.pendingPartners.push(data as Partner);
    });
  }

  async getRejectedPartners() {
    const snapshot = await firebase.firestore().collection('recycledPartners').get();
    snapshot.forEach((doc) => {
      const data = { id: doc.id, ...doc.data() };
      this.rejectedPartners.push(data as Partner);
    });
  }

  async getRejectedProjects() {
    const snapshot = await firebase.firestore().collection('recycledProjects').get();
    snapshot.forEach((doc) => {
      const data = { id: doc.id, ...doc.data() };
      this.rejectedProjects.push(data as Project);
    });
  }
}
